import styled from 'styled-components';
import {device} from 'styled/device';

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  .goToPaymentButton {
    font-size: 20px;
    font-weight: 500;
    justify-content: center;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ModalHeader = styled(Col)`
  display: flex;
  flex-direction: column;
  text-align: center;
  /* padding: 0 0 20px 0; */

  .desktopImage {
    padding-bottom: 15px;
  }

  .modalTitle {
    font-size: 28px;
    font-weight: 400;
    color: #23262f;
  }

  .modalMobileTitle {
    display: none;
  }

  .modalSubTitle {
    font-size: 16px;
    font-weight: 400;
    color: #777e90;
    padding-bottom: 30px;
  }

  @media (max-width: ${device.mobileM}) {
    .desktopImage {
      display: none;
    }

    .modalTitle {
      display: none;
    }

    .modalMobileTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-size: 30px;
      font-weight: 400;
      color: #23262f;
      padding-bottom: 20px;
    }

    .modalSubTitle {
      font-size: 18px;
    }
  }
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  font-size: 17px;
  font-weight: 400;
  color: #161643;

  @media (max-width: ${device.mobileM}) {
    font-size: 18px;
  }
`;

export const NewPhoneOrEmailButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #353945;
  margin-left: 5px;
  font-size: 16px;
  font-weight: 500;
  gap: 4px;
  span {
    padding-right: 4px;
  }

  @media (max-width: ${device.mobileM}) {
    font-size: 20px;
    font-weight: 500;
  }
`;
